module.exports = __webpack_public_path__ + "img/TZS09652.de23db30.jpeg";